export const useStorage = () => {
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  let user = localStorage.getItem('user');

  if (user) {
    user = JSON.parse(user);
  }

  return { isAdmin, user }
};